<header class="modal__header">
  <h2 class="modal__title" matDialogTitle></h2>
  <button mat-icon-button color="primary" class="modal__close" title="{{'APP.GENERAL.CLOSE' | translate}}"  mat-dialog-close (click)="cancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</header>

<section class="modal__content">
  <p class="text-center"> {{ data.contentKey | translate}} </p>
</section>

<div class="modal__footer">
  <button type="button" class="button button--warn" mat-dialog-close (click)="cancel()">
    <span>{{ data.cancelKey | translate }}</span>
  </button>
  <button type="button" class="button button--secondary" mat-dialog-close (click)="no()">
    <span>{{ data.noKey | translate }}</span>
  </button>
  <button type="button" class="button button--primary" (click)="yes()">
    <span>{{ data.yesKey | translate }}</span>
  </button>
</div>
